import { render, staticRenderFns } from "./PendingTransactions.vue?vue&type=template&id=7e52180c&scoped=true"
import script from "./PendingTransactions.vue?vue&type=script&lang=js"
export * from "./PendingTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e52180c",
  null
  
)

export default component.exports